import { FilterIcon, RotateCcw } from "lucide-react";
import { Card } from "../../../shared/card/card.tsx";
import { Button, Select, type SelectOption } from "../../../ui/index.ts";

import styles from "./probation-review-toolbar.module.css";

const DEFAULT_STATUS_OPTIONS: SelectOption[] = [
  { value: "", label: "All" },
  { value: "IN_PROGRESS", label: "In Progress" },
  { value: "COMPLETED", label: "Completed" },
  { value: "REJECTED", label: "Rejected" },
  { value: "APPROVED", label: "Approved" },
  { value: "PENDING", label: "Pending" },
  { value: "EXTEND", label: "Extend" },
];

export type ProbationReviewToolbarProps = {
  statusOptions?: SelectOption[];
  statusFilter: string;
  onStatusFilterChange: (status: string) => void;
  employeeIdFilter: string;
  onEmployeeIdFilterChange: (employeeId: string) => void;
  employeeOptions: SelectOption[];
  employeesLoading: boolean;
  managerId: string;
  onReportingManagerChange: (value: string) => void;
  reportingManagerOptions: SelectOption[];
  reportingManagersLoading: boolean;
  onApply: () => void;
  onClear: () => void;
  loading: boolean;
};

export function ProbationReviewToolbar({
  statusOptions = DEFAULT_STATUS_OPTIONS,
  statusFilter,
  onStatusFilterChange,
  employeeIdFilter,
  onEmployeeIdFilterChange,
  employeeOptions,
  employeesLoading,
  managerId,
  onReportingManagerChange,
  reportingManagerOptions,
  reportingManagersLoading,
  onApply,
  onClear,
  loading,
}: ProbationReviewToolbarProps) {
  return (
    <Card padding="3xl" className={styles.card}>
      <div className={styles.grid}>
    
        <div className={styles.fieldEmployee}>
          <Select
            label="Employee Name"
            placeholder={employeesLoading ? "Loading…" : "Select Employee Name"}
            searchable
            isClearable
            disabled={employeesLoading}
            value={employeeIdFilter}
            onChange={onEmployeeIdFilterChange}
            options={employeeOptions}
          />
        </div>
        <div className={styles.fieldEmployee}>
          <Select
            label="Reporting Manager"
            placeholder={reportingManagersLoading ? "Loading..." : "Select Reporting Manager"}
            searchable
            isClearable
            disabled={reportingManagersLoading}
            value={managerId}
            onChange={onReportingManagerChange}
            options={reportingManagerOptions}
          />
        </div>
            <div className={styles.fieldStatus}>
          <Select
            label="Status"
            placeholder="All"
            isClearable
            value={statusFilter}
            onChange={onStatusFilterChange}
            options={statusOptions}
          />
        </div>
        <div className={styles.actions}>
          <Button onClick={onApply} disabled={loading} startIcon={<FilterIcon size={14} aria-hidden />}
          >Apply Filter</Button>
          <Button variant="muted-outline" onClick={onClear} disabled={loading} startIcon={<RotateCcw size={14} aria-hidden />}
          >Clear Filter</Button>
        </div>
      </div>
    </Card>
  );
}
